import { foodImage } from "@/assets";

const Template1 = ({ template, previewData }) => {
  const isStrictPreview = Boolean(previewData?.strictTablePreview);
  const fallback = (value, defaultText) => {
    if (value === null || value === undefined || value === "") {
      return isStrictPreview ? "" : defaultText;
    }
    return value;
  };

  const backgroundImage =
    template?.image_url ||
    template?.image?.file_url ||
    template?.file_url ||
    previewData?.image_url ||
    previewData?.image?.file_url ||
    previewData?.template?.image_url ||
    previewData?.template?.image?.file_url ||
    foodImage;
  const title = fallback(previewData?.title, "Points Award");
  const customerName = fallback(previewData?.customerName, "Royel Tanduri");
  const code = fallback(previewData?.code, "32154232");
  const eligiblePoints = fallback(previewData?.eligibleRewardPoints, "50");
  const minimumRequiredPoints = fallback(previewData?.minimumRequiredPoints, "5");
  const rewardLabel = previewData?.rewardLabel || "";
  const offerSentence = rewardLabel ? `For ${eligiblePoints} points get ${rewardLabel} off` : `For ${eligiblePoints} points get reward`;
  const eligibilitySentence = `Minimum ${minimumRequiredPoints} points to be eligible for this offer`;
  const message = fallback(previewData?.message || previewData?.template_note, "Wish you a happy day.");
  const isConjunction = previewData?.isConjunction ?? previewData?.is_conjunction ?? (isStrictPreview ? false : true);

  return (
    <div className="flex items-center justify-center p-4">
      {/* Main Card Container */}
      <div
        data-export-capture="point-based-template"
        className="relative w-full max-w-2xl h-[300px] shadow-2xl overflow-hidden rounded-sm flex items-end justify-center"
      >
        <div
          className="absolute inset-0 w-full h-full bg-cover bg-center"
          style={{
            backgroundImage: `url(${backgroundImage})`,
          }}
        ></div>

        <div className="relative z-10 w-[82%] h-[82%] bg-[#4A8A99] shadow-2xl flex flex-col items-center justify-between text-white p-6 text-center">
          {/* Header Section */}
          <div className="w-full">
            <h1 className="text-2xl font-bold tracking-tight mb-0.5">
              {title}
            </h1>
            <p className="text-base font-serif italic opacity-95 mb-1.5">
              {customerName}
            </p>
            <div className="flex items-center justify-center gap-2.5 text-xs">
              <span className="bg-black/20 px-2 py-0.5 rounded">Code: {code}</span>
              {rewardLabel && (
                <span className="bg-white/20 px-2 py-0.5 rounded font-semibold text-yellow-300">
                  Offer: {rewardLabel}
                </span>
              )}
            </div>
          </div>

          {/* Points Section */}
          <div className="my-1.5 px-4 w-full">
            <h2 className="text-2xl font-extrabold tracking-tight leading-tight mb-1">
              {offerSentence}
            </h2>
            <p className="text-xs opacity-90 font-medium">
              {eligibilitySentence}
            </p>
          </div>

          {/* Message Section */}
          <div className="w-full">
            {message ? (
              <p className="text-xs italic opacity-80 max-w-md line-clamp-1 mx-auto">
                {message}
              </p>
            ) : (
              <div className="h-3" />
            )}
            {isConjunction && (
              <p className="text-[10px] opacity-75 font-semibold text-yellow-200 mt-0.5">
                Not conjunction with any other offer
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Template1;
